<template>
  <div>
    <payment-form
      payment-list="/api/payment/list"
      @close="$router.push('/admin/payment/list')"
      @list="$router.push('/admin/payment/list')"
      @change="id=> $router.push('/admin/payment/change?id=' + id)"
      @view="id=> $router.push('/admin/payment/view?id=' + id)"
    />
  </div>
</template>

<script>
  export default {
    props: ['create', 'change', 'view'],
    data: () => ({

    }),
    computed: {

    },
    watch: {

    },
    methods: {

    },
  }
</script>
